import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { NzConfigService } from 'ng-zorro-antd/core/config';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],

  template: '<router-outlet></router-outlet>',
})
export class AppComponent {
  title = 'corefluens-master';

  constructor(
    library: FaIconLibrary,
    private readonly nzConfigService: NzConfigService
  ) {
    // Add multiple icons to the library
    library.addIconPacks(far, fas, fal);

    this.nzConfigService.set('dropDown', { nzBackdrop: true });
  }

  ngOnInit(): void {
  }

}
